import { User } from '../user/user';

export interface HasOwner {
  id: string;
  ownerType: string;
  label: string;
}

export class FileOwner implements HasOwner {
  ownerId: string;
  ownerType: string;
  ownerLabel: string;

  constructor(payload?: any) {
    if (payload) {
      this.ownerId = payload.ownerId;
      this.ownerType = payload.ownerType;
      this.ownerLabel = payload.ownerLabel;
    }
  }

  get id(): string {
    return this.ownerId;
  }

  get label(): string {
    return this.ownerLabel;
  }
}

export class File {
  id: string;
  fileName: string;
  fullName: string;
  fullPath: string;
  uploadedDateTime: Date;
  extension: string;
  size: number;
  contentType: string;
  state: string;
  createdDateTime: Date;
  createdBy: User;
  lastModifiedBy: User;
  lastModifiedDateTime: Date;
  fileOwners: FileOwner[];

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.fileName = payload.fileName;
      this.fullName = payload.fullName;
      this.contentType = payload.contentType;
      this.fullPath = payload.fullPath;
      this.state = payload.state;
      if (payload.uploadedDateTime) {
        this.uploadedDateTime = new Date(payload.uploadedDateTime);
      }
      this.extension = payload.extension;
      this.size = payload.size;
      if (payload.createdDateTime) {
        this.createdDateTime = new Date(payload.createdDateTime);
      }
      if (payload.createdBy) {
        this.createdBy = new User(payload.createdBy);
      }
      if (payload.lastModifiedDateTime) {
        this.lastModifiedDateTime = new Date(payload.lastModifiedDateTime);
      }
      if (payload.lastModifiedBy) {
        this.lastModifiedBy = new User(payload.lastModifiedBy);
      }
      if (payload.fileOwners) {
        this.fileOwners = payload.fileOwners.map((owner: any) => new FileOwner(owner));
      }
    }
  }

  getFirstFileOwner(): FileOwner | undefined {
    return this.fileOwners?.[0];
  }

  static createFiles(result: Array<any>): File[] {
    const files = new Array<File>();
    if (result) {
      result.map((item) => {
        files.push(new File(item));
      });
    }
    return files;
  }
}

export class FileInput {
  id: string;
  key: string;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.key = payload.key;
    }
  }
}

export enum FileTypes {
  PDF = 'application/pdf',
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  PNG = 'image/png'
}
